import {customElement, bindable, bindingMode} from "aurelia-framework";
import {noop, delay, get} from "lodash";

@customElement('group-icon')
export class GroupIcon {

  /**
   * @type {{
   *  id: number,
   *  guid: string,
   *  name: string,
   *  type: string,
   *  hasSubgroups: boolean,
   *  [thumbLogoUrl]: string
   * } | null}
   */
  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) data = null;

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) hovered = noop;

  @bindable({
    defaultBindingMode: bindingMode.oneTime
  }) selected = noop;

  @bindable({
    defaultBindingMode: bindingMode.oneWay
  }) siblingSelected = null;

  groupName = '';
  thumbnailUrl = null;
  showShortName = false;
  hasSubgroups = false;
  isSelected = false;
  isDirectSelected = false;
  __isHovered = false;
  /** @type {Element} */
  thumbnailEl;
  shortName: string;
  private _mouseLeaveTimerId: number;
  private __mouseLeaveTimerId: number;
  private __mouseEnterTimerId: number;

  bind() {
    this.groupName = this.__ellipsizeText(this.data.name);
    this.thumbnailUrl = this.data.thumbLogoUrl;
    this.showShortName = !this.thumbnailUrl;
    this.shortName = this.data.shortName;
    this.hasSubgroups = this.data.hasSubgroups;
    this.siblingSelectedChanged(this.siblingSelected);
  }

  onMouseEnter() {
    clearTimeout(this.__mouseLeaveTimerId);

    if (!this.__isHovered) {
      this.__mouseEnterTimerId = delay(() => {
        this.__isHovered = true;
        this.hovered({
          id: this.__getId(),
          isHovered: this.__isHovered,
          top: this.__getTopClientPosition()
        });
      }, 0);
    }
  }

  onMouseLeave() {
    clearTimeout(this.__mouseEnterTimerId);

    if (this.__isHovered) {
      this.__mouseLeaveTimerId = delay(() => {
        this.__isHovered = false;
        this.hovered({id: this.__getId(), isHovered: this.__isHovered});
      }, 0);
    }
  }

  onClick() {
    this.selected({
      selection: {
        id: this.__getId(), selected: this.isSelected, direct: this.isDirectSelected,
      }
    });
  }

  siblingSelectedChanged(newValue) {
    this.isSelected = newValue.id == this.__getId();
    this.isDirectSelected = newValue.direct;
  }

  /**
   * @return {number}
   * @private
   */
  __getId() {
    return get(this.data, 'id', -1);
  }

  __getTopClientPosition() {
    let clientRect = this.thumbnailEl.getBoundingClientRect();
    return clientRect.top + this.thumbnailEl.offsetHeight / 2;
  }

  __ellipsizeText(text) {
    if (text.length > 30) return text.slice(0, 31) + '...';
    return text;
  }

}

/*export class ShortNameValueConverter {
  toView(value) {
    return value ? _.words(value).map(v => v[0]).slice(0, 2).join('').toUpperCase() : '';
  }
}*/

export class ThumbnailStyleValueConverter {
  toView(value) {
    return value ? `background-image: url("${value}");` : '';
  }
}
